var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportSpam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_39174_131042)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39174_131042)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4858 16.4864C28.4858 14.0086 26.4772 12 23.9995 12C21.5217 12 19.5131 14.0086 19.5131 16.4864C19.5131 18.0272 20.2899 19.3867 21.4735 20.1933C18.8658 21.0711 16.8381 23.2734 16.2509 26.0584C16.2093 26.2554 16.1765 26.5495 16.1484 26.9552C16.0735 28.0401 16.8922 28.9803 17.9771 29.0553L18.0449 29.0588L24.3746 29.0594C24.0716 28.6993 23.8146 28.2991 23.6126 27.8681H18.1128C18.0949 27.8681 18.0771 27.8674 18.0592 27.8662C17.6311 27.8366 17.3079 27.4655 17.3375 27.0374L17.3592 26.7597C17.3779 26.5503 17.3976 26.3968 17.4171 26.3043C18.068 23.2178 20.8043 20.9727 23.9995 20.9727C24.4841 20.9727 24.9581 21.0244 25.4159 21.1227C25.8888 20.7909 26.4171 20.5327 26.9842 20.3646C26.8335 20.3033 26.6806 20.2465 26.5257 20.1944C27.709 19.3867 28.4858 18.0272 28.4858 16.4864ZM20.705 16.4864C20.705 14.6669 22.18 13.1919 23.9995 13.1919C25.8189 13.1919 27.2939 14.6669 27.2939 16.4864C27.2939 18.3058 25.8189 19.7808 23.9995 19.7808C22.18 19.7808 20.705 18.3058 20.705 16.4864Z",
    fill: "#8B93A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 21C27.61 21 26.74 21.2639 25.9999 21.7584C25.2599 22.2529 24.6831 22.9557 24.3425 23.7779C24.0019 24.6002 23.9128 25.505 24.0865 26.3779C24.2601 27.2508 24.6887 28.0526 25.318 28.682C25.9474 29.3113 26.7492 29.7399 27.6221 29.9135C28.495 30.0872 29.3998 29.9981 30.2221 29.6575C31.0443 29.3169 31.7471 28.7401 32.2416 28.0001C32.7361 27.26 33 26.39 33 25.5C32.9987 24.3069 32.5242 23.1631 31.6806 22.3194C30.8369 21.4758 29.6931 21.0013 28.5 21ZM28.5 22.125C29.1999 22.1261 29.8818 22.3464 30.4499 22.7551L25.7547 27.4494C25.3938 26.9458 25.179 26.3524 25.1339 25.7345C25.0888 25.1166 25.2152 24.4983 25.4991 23.9476C25.783 23.397 26.2134 22.9354 26.7429 22.6138C27.2725 22.2922 27.8805 22.1231 28.5 22.125ZM28.5 28.875C27.8001 28.8739 27.1182 28.6536 26.5501 28.2449L31.2453 23.5506C31.6062 24.0542 31.821 24.6476 31.8661 25.2655C31.9112 25.8834 31.7848 26.5017 31.5009 27.0524C31.217 27.603 30.7866 28.0646 30.2571 28.3862C29.7276 28.7078 29.1195 28.8769 28.5 28.875Z",
    fill: "#8B93A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_39174_131042",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39174_131042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39174_131042",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39174_131042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(15 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportSpam);
export default __webpack_public_path__ + "static/media/report-spam.f8ee7811f4a3f0a7cdbd3502d64662e8.svg";
export { ForwardRef as ReactComponent };